const ITEMS = [
  "Extensions",
  "Renovations",
  "Project Management",
  "New Builds",
  "Conversions",
  "Refurbishments",
  "Property Development",
  "Essex",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[#C5A059]/15 bg-[#0A111E] py-6"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-2xl font-light uppercase tracking-[0.2em] text-white/25 sm:text-3xl">
                  {item}
                </span>
                <span className="mx-10 inline-block h-1.5 w-1.5 rotate-45 bg-[#C5A059]/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
